import React, { useState, useEffect } from 'react'
import noop from 'lodash/noop'
import { TextInputOld, Button, Dropdown, IDropdownItem } from '@doseme/cohesive-ui'
import { isLoaded, isLoading } from 'flux-entities'
import moment from 'moment'

import { IUser } from '../../../../types/user'
import { TProps } from './types'
import { USERS_URL } from '../../../../constants/urls/frontend'
import { FormPageLayout } from '../../../../components/FormPageLayout'
import { StyledForm } from '../../../../components/StyledForm'
import { ILabelWithValue } from '../../../../components/SubscriptionsInputModal/types'

const Edit: React.FC<TProps> = (props) => {
  const { users, fetchUsers, updateUser, installations, fetchInstallations, history, match } = props

  const [copy, updateCopy] = useState<IUser>({
    id: 0,
    email: '',
    installation: 0,
    lastLogin: moment(),
    created: moment(),
    updated: moment()
  })
  const [error, updateError] = useState('')

  useEffect(() => {
    if (!users.touched) {
      fetchUsers()
    }
  }, [users.touched, fetchUsers])

  useEffect(() => {
    if (!installations.touched) {
      fetchInstallations()
    }
  }, [installations.touched, fetchInstallations])

  useEffect(() => {
    const loadedUser = users.all[match.params.id]
    if (loadedUser) {
      updateCopy(loadedUser)
    }
  }, [users.all, updateCopy, match.params.id])

  const user = users.all[match.params.id]

  if (!user && isLoaded(users)) {
    return <div>No user was found with the id {match.params.id}</div>
  }

  if (copy.id === 0 || !isLoaded(installations)) {
    return <div>Loading...</div>
  }

  const handleSubmit = async (evt: React.FormEvent<HTMLFormElement>) => {
    evt.preventDefault()
    updateError('')

    const { status, message } = await updateUser({ ...copy, updated: moment() })
    if (status >= 400) {
      updateError(message)
      return
    }

    history.push(USERS_URL)
  }

  const handleInstallationSelect = (item: IDropdownItem) => {
    const numericId = parseInt(item.value, 10)
    updateCopy({ ...copy, installation: numericId })
  }

  const installationList = installations.ids.reduce<ILabelWithValue[]>((acc, curr) => {
    return [
      ...acc,
      {
        label: installations.all[curr].code,
        value: installations.all[curr].id.toString()
      }
    ]
  }, [])

  return (
    <FormPageLayout
      title='Edit User'
      subtitle={`${user.email} - ${installations.all[user.installation]?.code}`}
      handleBackClick={() => history.push(USERS_URL)}
    >
      <StyledForm handleSubmit={handleSubmit}>
        <TextInputOld
          label='Email'
          data-test='email'
          name='email'
          type='text'
          defaultValue={copy.email}
          onChange={noop}
          readOnly
          disabled
        />
        <br />

        <Dropdown
          fieldState='valid'
          showSearchThreshold={0}
          placeholder={installations.all[copy.installation].code}
          data={installationList}
          onSelect={handleInstallationSelect}
        />
        <br />
        <hr />

        <div className='d-flex w-100 justify-content-end'>
          <Button type='submit' variant='primary' onClick={noop} loading={isLoading(users)}>
            Update
          </Button>
        </div>
      </StyledForm>

      {error}
    </FormPageLayout>
  )
}

export { Edit }
